import { orderTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const orderUpdate = (state = defaultState, action) =>
  commonReducer(actionTypes.UPDATE, state, action);
